import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Stack, Typography } from "@mui/material";
import { GripVerticalIcon } from "component/Icons";
import { HospitalRouteItemContainer } from "./HospitalRouteItemContainer";
interface Props {
  id: number | string;
  isAnimating: boolean;
  content: string;
}

export const SortableHospitalRouteItem = ({ id, content, isAnimating }: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = isAnimating
    ? {
        transform: CSS.Transform.toString(transform),
        transition,
      }
    : undefined;

  return (
    <Stack ref={setNodeRef} style={style}>
      <Stack sx={{ flexDirection: "row", alignItems: "center", gap: "4px" }}>
        <Stack sx={{ cursor: "grab" }} {...attributes} {...listeners}>
          <GripVerticalIcon width={24} height={24} />
        </Stack>
        <HospitalRouteItemContainer>
          <Typography variant="body2">{content}</Typography>
        </HospitalRouteItemContainer>
      </Stack>
    </Stack>
  );
};
